/**
 * Calculates the payment fee for a given subtotal and fee config.
 * Mirrors server-side logic — frontend is display-only, server is authoritative.
 *
 * @param {number} subtotal - Cart subtotal in EUR
 * @param {{ fixedFee: number, percentageFee: number }} feeConfig - Fee config from API
 * @returns {number} Fee amount rounded to 2 decimal places
 */
export function calculatePaymentFee(subtotal, feeConfig) {
  if (!feeConfig) return 0;
  const fixed = feeConfig.fixedFee || 0;
  const percentage = feeConfig.percentageFee || 0;
  const fee = fixed + Math.round(subtotal * percentage * 100) / 100;
  return Math.round(fee * 100) / 100;
}
